import React from 'react'
import ButtonPrimary from 'components/ButtonPrimary'
import Row from 'components/Row.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { isAppleOrAndroidPhoneOrTabletPlatformUtil } from 'utils/device/utils/get-platform'
import getUserAgentAppSelect from 'modules/training/modules/app/selectors/get-user-agent'
import { View } from 'components/View.js'
import TextBodySmall from 'components/TextBodySmall/index.js'

/**
 * @param onClick
 * @param text
 * @param installedText
 * @returns {JSX.Element}
 * @constructor
 */
export function ViewInApp ({
  onClick,
  installedText,
  text
}) {
  const userAgent = useSelector(getUserAgentAppSelect)

  if (!isAppleOrAndroidPhoneOrTabletPlatformUtil(userAgent)) {
    return <></>
  }

  return (
    <View mt>
      <View
        px={4}
        mb
      >
        <TextBodySmall ta>
          {installedText}
        </TextBodySmall>
      </View>

      <Row
        jc
      >
        <ButtonPrimary
          onClick={onClick}
        >
          {text}
        </ButtonPrimary>
      </Row>
    </View>
  )
}
